export const FLOW_NAME = "sales-effectiveness";
export type FLOW_TYPE = "sales-effectiveness";

export const INPUT_DATA = "input-data";
export const AUGMENTED_FILE = "augmented-data";

export const SUCCESS_DEFINITION_KEY = "success-definition";
export const SUCCESS_COLUMN_KEY = "success-column";
export const DEFAULT_SUCCESS_COLUMN_NAME = "success (auto-created)";

export const LEVEL_TAGS = { 0: "Lost", 1: "Won" };

export const RECIPE =
  "what-is-the-probability-of-y-happening-generic-recipe-single-file";

export const ALGOS = [
  "boosted-trees",
  "bayesian-probit",
  "supervised-clustering",
];

export const RUN_ID = "RUN_ID";
export const INIT_RUN = "INIT_RUN";
export const CREATED_BY = "CREATED_BY";
export const TIME_STAMP = "TIME_STAMP";

export const TIME_VARIABLE_KEY = "time";
export const LABEL_VARIABLES_KEY = "id-vars";
export const ENTITY_VARIABLES_KEY = "entity-vars";

export const GROUPING_VARIABLES_KEY = "group-vars";
export const BUILD_GROUP_MODELS_KEY = "build-group-models";

export const IS_APP_KEY = "is-app";
export const MODELS_FOR_APP_KEY = "models-for-app";
export const COL_TYPES_KEY = "col-types";

export const BUILD_NEW_MODELS_LINK = "build-new-models";
export const MODELS_SUMMARY_LINK = "models-summary";
